window.Node = [
    { nodename:'创建标段', nodecode:'A01001', addUrl:'/bidding/projectflow/fangan/biaoduan/form?procode=' },
    { nodename:'创建标段', nodecode:'A02001', addUrl:'/bidding/projectflow/fangan/biaoduan/form?procode=' },
    { nodename:'标段管理', nodecode:'A03001', addUrl:'/bidding/projectflow/fangan/biaoduan/form?procode=' },
]